import moment from 'moment';

export const isAbove18years = date => moment().diff(moment(date), 'years', true) >= 18;
export const formatDate = date => moment(date).format('DD/MM/YYYY')


// WEBPACK FOOTER //
// ./src/utils/loaLawyerHelpers.js